// extracted by mini-css-extract-plugin
module.exports = {"nav":"Download_nav__fYPW_","content":"Download_content__35tTK","card":"Download_card__3G5fV"};